<template>
  <p class="flex items-center gap-2 text-sm font-medium tracking-tight text-brand-800" role="status">
    <span class="relative flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-100">
      <span class="absolute inline-flex h-full w-full rounded-full bg-brand-200 opacity-60 animate-ping" />
      <CursorClickIcon class="relative h-3.5 w-3.5 text-brand-600" aria-hidden="true" />
    </span>
    {{ text }}
  </p>
</template>

<script>
import { CursorClickIcon } from '@heroicons/vue/solid'

export default {
  name: 'FulfillmentChoiceHint',
  components: { CursorClickIcon },
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>
